export default "__VITE_ASSET__7cd2185a__"